import * as React from 'react';
import styled from 'styled-components';
import EventCreation from '../../../components_v2/creation/EventCreation';
import NoteCreation from '../../../components_v2/creation/NoteCreation';
import { PrimaryColor } from '../../../styles/global/css/Utils';
import { FlexDiv } from '../../products/style';
import { CompanyDetail } from '../model/Model';
import Restricted from '../../permissions/Restricted';
import { ObjectAction } from '../web-types/objectActions';
import EmailTemplatePopup from '../../email-templates/emailTemplatePopup';
import { Calendar, FilePlus, Mail, Phone } from 'lucide-react';

interface QuickAction {
	img: JSX.Element
	onClick: () => void
	style?: React.CSSProperties
	objectAction?: ObjectAction
}

const QuickActionDiv = styled.div`
    cursor: pointer;
    border: 1px solid ${PrimaryColor};
    border-radius: 50%;
    width: 28px;
	min-width: 28px;
    height: 28px;
    padding: 6px;
    display: flex;
    justify-content: center;
	align-items: center;
`;

export default function QuickActions(props: {
	company?: CompanyDetail,
	onCreate: () => void,
	isSelf: boolean
}) {
	const [isNoteOpen, setIsNoteOpen] = React.useState<boolean>(false);
	const [isEventOpen, setIsEventOpen] = React.useState<boolean>(false);
	const [isEmailTemplateOpen, setIsEmailTemplateOpen] = React.useState(false);

	const { company } = props;
	const actions: QuickAction[] = [
		{
			img: <FilePlus color={PrimaryColor} />,
			onClick: () => setIsNoteOpen(true),
			style: { marginLeft: 2, width: 20 }
		},
		{
			img: <Phone color={PrimaryColor} />,
			onClick: () => window.open(`tel:${company?.company_phone}`),
			style: { width: 19 }
		},
		{
			img: <Mail color={PrimaryColor} />,
			onClick: () => setIsEmailTemplateOpen(prev => !prev)
		},
		{
			img: <Calendar color={PrimaryColor} />,
			onClick: () => setIsEventOpen(true),
			objectAction: 'CreateEvent'
		}
	];
	return <div style={{ width: '100%' }}>
		<FlexDiv justify='center' width="100%" padding="8px 15% 5px 15%" gap='10px'>
			{actions.map(({ img, onClick, objectAction }, i) => <Restricted to={objectAction ? { objectAction } : []} key={`QuickAction[${i}]`} isSelf={props.isSelf}>
				<QuickActionDiv onClick={onClick}>
					{img}
				</QuickActionDiv>
				{i === 2 && isEmailTemplateOpen && company && company.company_email &&
					<EmailTemplatePopup
						emailTemplateVariable={{
							first_name: company.owner_name.split(' ')[0] ?? '',
							last_name: company.owner_name.split(' ')[1] ?? '',
							company_name: company.company_name ?? ''
						}}
						email={company?.company_email ?? ''}
						isOpen={isEmailTemplateOpen}
						onClose={() => setIsEmailTemplateOpen(false)}
						quickAction
					/>
				}
			</Restricted>
			)}
		</FlexDiv>
		<NoteCreation
			isOpen={isNoteOpen}
			setOpen={(b: boolean) => setIsNoteOpen(b)}
			id={props.company ? { Company: props.company?.company_id } : undefined}
			onCreate={() => props.onCreate()}
		/>
		<EventCreation
			isOpen={isEventOpen}
			setOpen={(b: boolean) => setIsEventOpen(b)}
			clientCompanyId={props.company?.company_id}
			onCreate={() => props.onCreate()}
		/>
	</div>;
}
